import React from "react";
import { PaperclipIcon } from "@phosphor-icons/react";
import { DashedAddButton } from "../../DashedAddButton";

interface AddDocumentButtonProps {
  label: string;
  onClick: () => void;
  loading?: boolean;
}

/**
 * "Add a document" affordance shared by the create and edit Documents cards.
 * Renders the same `DashedAddButton` as the rail's "Add a new add-on" button,
 * so the two dashed "add" patterns can't drift apart — only the icon differs.
 */
export const AddDocumentButton: React.FC<AddDocumentButtonProps> = ({
  label,
  onClick,
  loading,
}) => (
  <div style={{ marginTop: 12 }}>
    <DashedAddButton
      icon={<PaperclipIcon size={16} weight="bold" />}
      label={label}
      onClick={onClick}
      loading={loading}
      iconBordered={false}
      centered
    />
  </div>
);
